import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { Film } from "lucide-react";

export function CreatorLicenceGate({ children }) {
  const [status, setStatus] = useState(null);
  const [ticked, setTicked] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/legal/status").then(({ data }) => setStatus(data)).catch(() => setStatus({ stage_terms_accepted: true })); }, []);
  if (!status) return null;
  if (status.stage_terms_accepted) return children;
  const accept = async () => {
    setBusy(true);
    try { const { data } = await api.post("/legal/accept", { docs: ["stage-terms"], context: "stage-studio" }); setStatus(data); }
    finally { setBusy(false); }
  };
  return (
    <div className="max-w-2xl mx-auto px-6 py-16" data-testid="creator-licence-gate">
      <div className="rounded-2xl border border-[#FF3B30]/30 bg-gradient-to-br from-[#1a0b0b] via-[#121212] to-[#0a0a0a] p-8">
        <div className="inline-flex items-center gap-2 text-[#FF3B30] text-[10px] uppercase tracking-[0.25em]"><Film className="h-3.5 w-3.5" /> Before you open your Stage</div>
        <h1 className="mt-3 text-2xl sm:text-3xl font-black tracking-tight text-white">Your content, your copyright — our licence to show it off</h1>
        <ul className="mt-5 space-y-2 text-sm text-neutral-300">
          <li>• <span className="text-white font-semibold">You keep ownership</span> of everything you upload or stream, and you can publish it anywhere else.</li>
          <li>• You give VISMARKS a <span className="text-white font-semibold">worldwide, non-exclusive, royalty-free, sublicensable licence</span> to host, promote, clip and share it — on the Platform, in Official Stage highlights, on our social channels and in ads.</li>
          <li>• The licence ends when you delete content, except it stays <span className="text-white font-semibold">perpetual and irrevocable</span> for promotional clips we already made, content others already shared, backups and legal copies.</li>
          <li>• Tips are final after 24h; tickets refund if a show is cancelled; memberships cancel anytime. Platform fee 0.5% on Stage payments.</li>
          <li>• Use only music and footage you have rights to — or the licence-free beds in Stage Studio.</li>
        </ul>
        <label className="mt-6 flex items-start gap-3 cursor-pointer rounded-md border border-[#27272A] bg-black/30 p-3.5">
          <input type="checkbox" checked={ticked} onChange={(e) => setTicked(e.target.checked)} data-testid="creator-licence-checkbox" className="mt-0.5 h-4 w-4 accent-[#FF3B30]" />
          <span className="text-xs text-neutral-300 leading-relaxed">I have read and agree to the <Link to="/stage-terms" target="_blank" className="text-[#007AFF] hover:underline">Stage & Creator Terms</Link>, including the content licence above. This is my electronic signature.</span>
        </label>
        <Button onClick={accept} disabled={!ticked || busy} data-testid="creator-licence-accept-btn" className="mt-5 h-11 px-6 rounded-full bg-[#FF3B30] hover:bg-[#e6352b] text-white font-bold">
          {busy ? "Saving…" : "Agree and open Stage Studio"}
        </Button>
      </div>
    </div>
  );
}
